(function($) {
    'use strict';
    $(function() {
    /********
     * SWIPER SLIDES
     * Description: http://idangero.us/swiper/api/#.WdtkhxOCyEJ
     * Example:
    var testSlider = new Swiper('.swiper-container', {
        loop: true,
        autoplay: 4000,
        speed: 500,
        onInit: function(testSlider) {
            // Code..
        }
    })
    ********/

        var swiper1 = new Swiper('.front-articles.swiper-container', {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 30,
            loop: true,
            roundLengths: true,
            slideToClickedSlide: true,
            // navigation: {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev',
            // },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });


        var swiper2 = new Swiper('.gallery.swiper-container', {
            loop: true,
            // autoHeight: true,
            spaceBetween: 20,
            // effect: 'coverflow',
            centeredSlides: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });

    });
})(jQuery);
